import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { trpc } from "../lib/trpc";

/**
 * Süper-admin-only rota koruması. PageGate YALNIZ sayfa-anahtarı üyeliğini denetler (bir tesis
 * yöneticisi grubunda "forms" varsa PageGate'ten geçer) — bu bileşen EK olarak isSuperAdmin şartı
 * koyar. Süper-admin değilse `redirectTo`'ya yönlendirir. PageGate'in İÇİNDE kullanılır: önce sayfa
 * erişimi, sonra süper-admin şartı. NOT: UI kolaylığı; asıl güvenlik backend requireSuperAdmin'de.
 */
export function SuperAdminGate({ children, redirectTo = "/formlar/liste" }: { children: ReactNode; redirectTo?: string }) {
  const meQ = trpc.auth.me.useQuery(undefined, { staleTime: 60_000 });
  const user = meQ.data?.user;
  if (meQ.isLoading || !user) return null; // ProtectedRoute yükleme/oturum durumunu yönetir
  if ((user as { isSuperAdmin?: boolean }).isSuperAdmin) return <>{children}</>;
  return <Navigate to={redirectTo} replace />;
}
